const SECONDS_ONLY = /^\d+$/;

/**
 * Reads a `Retry-After` header value as whole seconds. It is either a number of seconds or an
 * HTTP date; a date in the past, or anything unreadable, gives `undefined`.
 */
export function parseRetryAfter(value: string | null | undefined, now: Date = new Date()): number | undefined {
  const text = value?.trim();
  if (!text) return undefined;
  if (SECONDS_ONLY.test(text)) return Number(text);
  const at = Date.parse(text);
  if (Number.isNaN(at)) return undefined;
  const seconds = Math.ceil((at - now.getTime()) / 1000);
  return seconds > 0 ? seconds : undefined;
}
